import MovieControls from './MovieControls'
export default MovieControls
